"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.limitOpenFiles = void 0;
const p_limit_1 = __importDefault(require("p-limit"));
const OPEN_FILE_LIMIT = Number(process.env.TF_FILE_LIMIT) || 1024;
exports.limitOpenFiles = p_limit_1.default(OPEN_FILE_LIMIT);
//# sourceMappingURL=utils.js.map